import React, { useEffect, useState } from "react";
import { Form, Input, Select, DatePicker, Row, Col } from "antd";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { addLiabilityPaymentThunk, fetchLiabilitiesThunk } from "../../../../Store/Slices/Finance/liabilities/liabilities.thunk";
import { fetchEntity } from "../../../../Store/Slices/Finance/entitie/entity.thunk";
import toast from "react-hot-toast";

const { Option } = Select;

const PayLiability = ({ open, onClose, liability }) => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const { bankEntities } = useSelector((s) => s.admin.entity);
  const {
    loading,
  } = useSelector((state) => state.admin.liabilities);

  const [receiptData, setReceiptData] = useState({
    paymentType: "cash",
    paymentDate: "",
    transactionId: "",
    chequeNumber: "",
    chequeDate: "",
    note: "",
    bankAccount: "",
    amount: liability?.emiAmount || 0,
  });
  // fetch bank accounts
  useEffect(() => {
    dispatch(fetchEntity({ search: "Bank", type: "bank", page: 1, limit: 1000 }));
  }, [dispatch]);
  const resetForm = () => {
    form.resetFields();

    setReceiptData({
      paymentType: "cash",
      paymentDate: "",
      transactionId: "",
      chequeNumber: "",
      chequeDate: "",
      note: "",
      bankAccount: null,
      amount: liability?.emiAmount || 0,
    });
  };

  const handleChange = (field, value) => {
    setReceiptData({
      ...receiptData,
      [field]: field.includes("Date") && value
        ? value.format("YYYY-MM-DD")
        : value,
    });
  };

  const handleSubmit = async () => {
    toast.dismiss()
    const payload = {
      amount: Number(receiptData.amount),
      paymentType: receiptData.paymentType,
      transactionId: receiptData.transactionId,
      note: receiptData.note,
      paymentDate: receiptData.paymentDate,
      chequeDate: receiptData.chequeDate,
      chequeNumber: receiptData.chequeNumber,
      bankAccount: receiptData.bankAccount || null,
    };

    try {
      const res = await dispatch(
        addLiabilityPaymentThunk({
          liabilityId: liability?._id,
          payload,
        })
      );

      if (!res.payload.success) {
        toast.error(res?.payload || "Payment failed");
      } else {

        toast.success(res?.payload?.message || "Payment successful");
        await dispatch(fetchLiabilitiesThunk());
        resetForm();
        onClose();
      }
    } catch (err) {

      toast.error(err || "Something went wrong");
    }
    finally {
      // toast.dismiss()
    }
  };

  return (
    <div className="p-5">
      <Form layout="vertical" form={form} onFinish={handleSubmit}>
        <Row gutter={16}>

          {/* Amount */}
          <Col span={12}>
            <Form.Item label="Amount" required>
              <Input
                type="number"
                value={receiptData.amount}
                onChange={(e) => handleChange("amount", e.target.value)}
              />
            </Form.Item>
          </Col>

          {/* Payment Type */}
          <Col span={12}>
            <Form.Item label="Payment Type" required>
              <Select
                value={receiptData.paymentType}
                onChange={(val) => handleChange("paymentType", val)}
              >
                <Option value="cash">Cash</Option>
                <Option value="card">Card</Option>
                <Option value="online">Online</Option>
                <Option value="cheque">Cheque</Option>
              </Select>
            </Form.Item>
          </Col>

          {/* Bank Account (only online/card) */}
          {(receiptData.paymentType === "online" ||
            receiptData.paymentType === "card") && (
              <Col span={12}>
                <Form.Item label="Bank Account">
                  <Select
                    value={receiptData.bankAccount}
                    onChange={(val) => handleChange("bankAccount", val)}
                    options={bankEntities.map((e) => ({
                      label: e.entityName,
                      value: e._id,
                    }))}
                    showSearch
                    allowClear
                  />
                </Form.Item>
              </Col>
            )}

          {/* Transaction ID */}
          {(receiptData.paymentType === "online" ||
            receiptData.paymentType === "card") && (
              <Col span={12}>
                <Form.Item label="Transaction ID">
                  <Input
                    value={receiptData.transactionId}
                    onChange={(e) =>
                      handleChange("transactionId", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>
            )}

          {/* Payment Date */}
          <Col span={12}>
            <Form.Item label="Payment Date" required>
              <DatePicker
                style={{ width: "100%" }}
                onChange={(val) => handleChange("paymentDate", val)}
              />
            </Form.Item>
          </Col>

          {/* Cheque Fields */}
          {receiptData.paymentType === "cheque" && (
            <>
              <Col span={12}>
                <Form.Item label="Cheque Number">
                  <Input
                    value={receiptData.chequeNumber}
                    onChange={(e) =>
                      handleChange("chequeNumber", e.target.value)
                    }
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item label="Cheque Date">
                  <DatePicker
                    style={{ width: "100%" }}
                    onChange={(val) => handleChange("chequeDate", val)}
                  />
                </Form.Item>
              </Col>
            </>
          )}

          {/* Note */}
          <Col span={12}>
            <Form.Item label="Note">
              <Input.TextArea
                rows={2}
                value={receiptData.note}
                onChange={(e) => handleChange("note", e.target.value)}
              />
            </Form.Item>
          </Col>

        </Row>

        <button
          disabled={loading}
          className="w-full btn-gradient px-4 py-2 mt-3"
        >
          Submit Payment
        </button>
      </Form>
    </div>
  );
};

export default PayLiability;